/**
 * Retorna a classe CSS de cor do marcador baseado no tipo.
 * Para tipo "interest" retorna verde (success),
 * para "avoid" retorna vermelho (danger),
 * e para outros casos retorna a cor padrão de rota.
 */
export const getMarkerColorByType = (type: "interest" | "avoid") => {
    if (type === "interest") return "bg-map-marker-success";
    if (type === "avoid") return "bg-map-marker-danger";
    return "bg-map-marker-route";
};